import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/dot-line.png'


const _withScopeId = n => (_pushScopeId("data-v-191b3614"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "row flex"
}
const _hoisted_2 = { class: "row-name" }
const _hoisted_3 = { class: "fx-1 flex-wrap" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_0,
  class: "no-event abs",
  alt: ""
}, null, -1))
const _hoisted_6 = {
  key: 1,
  class: "row flex"
}
const _hoisted_7 = { class: "row-name" }
const _hoisted_8 = { class: "fx-1 flex-wrap" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_0,
  class: "no-event abs",
  alt: ""
}, null, -1))
const _hoisted_12 = {
  key: 2,
  class: "row flex"
}
const _hoisted_13 = { class: "row-name" }
const _hoisted_14 = { class: "flex-1" }
const _hoisted_15 = { class: "form_item" }
const _hoisted_16 = {
  key: 3,
  class: "row flex"
}
const _hoisted_17 = { class: "row-name" }
const _hoisted_18 = { class: "flex-1" }
const _hoisted_19 = { class: "form_item" }
const _hoisted_20 = { class: "label-name" }
const _hoisted_21 = { class: "form_item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_0,
  class: "no-event abs",
  alt: ""
}, null, -1))
const _hoisted_23 = {
  key: 4,
  class: "row flex"
}
const _hoisted_24 = { class: "row-name" }
const _hoisted_25 = { class: "flex-1" }
const _hoisted_26 = { class: "form_item" }
const _hoisted_27 = { class: "form_item" }
const _hoisted_28 = { class: "row flex" }
const _hoisted_29 = { class: "row-name" }
const _hoisted_30 = { class: "fx-1 flex-wrap" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "flex-ter" }
const _hoisted_33 = { class: "btn" }

import { t } from '@/plugins/i18n'
import { ref, reactive, toRef, computed, watch, toRaw, nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import PriceRange from '@/components/common/PriceRange.vue'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import { useRtfix, useSite, isJA } from '@/store'
import { keywordList } from '@/views/product/CreateAssociated/components/CommonProduct/useCommonProduct'


export default /*#__PURE__*/_defineComponent({
  props: ['params', 'type'],
  setup(__props) {

const props = __props
const store = useStore()
const route = useRoute()
const router = useRouter()

const params = toRef(props, 'params')
// 是否需要国家站搜索条件
const isNational = computed(() =>
  isJA() && ((!!route.query.national && route.query.platformType === 'AM') ||
    (!keywordList.includes(route.query.keyword as string) && route.query.keyword && route.query.platformType === 'AM') ||
    (route.query.platformType === 'AM' && route.query.productCategoryFrontendId))
)

const onShowNation = computed(() => (isJA() && !!route.query.national))

const channels = [
  { label: '全部', value: '' },
  { label: '市场购', value: '1' },
  { label: '透明购', value: '2' }
]

/** 综合体验分 */
const totalEpScoreLv = ref<string>('')
/** 24小时揽收率 */
const getRate24HLv = ref<string>('')
/** 48小时揽收率 */
const getRate48HLv = ref<string>('')
/** 7天无理由 */
const noReason7DReturn = ref<boolean>(false)
/** 工厂认定 */
const certifiedFactory = ref<boolean>(false)
/** 服务保障 */
const serves = ref<string>('')
/** 分类 */
const categoryId = ref('0')

/** 过滤后参数处理 */
const changeFilter = ($event: any, type: string) => {
  console.log($event, type, 'type')
  const { filters } = route.query
  let queryArr: string[] = []
  const filtersArr = filters ? filters.toString().split(',') : []
  switch (type) {
    case 'totalEpScoreLvOptions':
      queryArr = filtersArr.filter(j => !totalEpScoreLvOptions.map(i => i.value).filter(i => i).includes(j))
      if ($event) queryArr.push($event)
      break
    case 'getRate24HLvOptions':
      queryArr = filtersArr.filter(j => !getRate24HLvOptions.map(i => i.value).filter(i => i).includes(j))
      if ($event) queryArr.push($event)
      break
    case 'getRate48HLvOptions':
      queryArr = filtersArr.filter(j => !getRate48HLvOptions.map(i => i.value).filter(i => i).includes(j))
      if ($event) queryArr.push($event)
      break
    case 'noReason7DReturn':
      queryArr = filtersArr.filter(j => j !== 'noReason7DReturn')
      if ($event) queryArr.push('noReason7DReturn')
      break
    case 'serveList':
      queryArr = filtersArr.filter(j => !serveList.map(i => i.value).filter(i => i).includes(j))
      if ($event.length) queryArr = queryArr.concat($event)
      break
    case 'certifiedFactory':
      queryArr = filtersArr.filter(j => j !== 'certifiedFactory')
      if ($event) queryArr.push('certifiedFactory')
      break
    default:
      break
  }
  const newFilter = queryArr.filter(i => !!i).join(',')
  const query = {
    ...route.query,
    filters: newFilter
  }
  nextTick(() => {
    router.replace({ ...route, query })
  })
}

const changeCategoryId = (e: any) => {
  const query = {
    ...route.query,
    categoryId: e
  }
  nextTick(() => {
    router.replace({ ...route, query })
  })
}

const categrayList = [
  { label: t('全部'), value: '0' },
  { label: 'レディースファッション', value: '10166' },
  { label: 'メンズファッション', value: '10165' },
  { label: '子供服', value: '311' },
  { label: 'インテリア', value: '96' },
  { label: 'スポーツ＆アウトドア', value: '18' },
  { label: 'ペット用品', value: '122916001' },
  { label: 'キッチン用品', value: '201547801' },
  { label: 'バッグ', value: '1042954' },
  { label: '収納', value: '1548' },
  { label: 'アクセサリー', value: '54' },
  { label: 'スマホ＆パソコン', value: '7' },
  { label: '車用品', value: '122916002' }
]

/** 体验分下拉  */
const totalEpScoreLvOptions = [
  { label: t('全部'), value: '' },
  { label: t('5星'), value: 'totalEpScoreLv1' },
  { label: t('4.5星~5.0星'), value: 'totalEpScoreLv2' },
  { label: t('4.0星~4.5星'), value: 'totalEpScoreLv3' }
  // { label: t('4星以下'), value: 'totalEpScoreLv4' }
]
/** 24小时揽收率 */
const getRate24HLvOptions = [
  { label: t('全部'), value: '' },
  { label: '>=99%', value: 'getRate24HLv3' },
  { label: '>=95%', value: 'getRate24HLv2' },
  { label: '<95%', value: 'getRate24HLv1' }
]

/** 48小时揽收率 */
const getRate48HLvOptions = [
  { label: t('全部'), value: '' },
  { label: '>=99%', value: 'getRate48HLv3' },
  { label: '>=95%', value: 'getRate48HLv2' },
  { label: '<95%', value: 'getRate48HLv1' }
]
/** 服务列表 */
const serveList = [
  { label: t('当日发货'), value: 'shipInToday' },
  { label: t('24小时发货'), value: 'shipIn24Hours' },
  { label: t('48小时发货'), value: 'shipIn48Hours' }
  // { label: t(''), value: 'noReason7DReturn' }
]

const sellers = computed(() => {
  const buss = store.state.bussiness

  const SellersList = [{ label: t('全部'), value: '', channel: '', tagImg: '' }].concat(
    buss.Sellers.slice(1).filter((v: any) =>
      params.value.schannel ? v.channel === params.value.schannel : true
    )
  )
  console.log(SellersList)

  // 找相似不需要为1688精选
  const { productCode } = route.query
  const item = SellersList.find(i => i.value === 'AM')
  if (item) {
    if (!productCode) {
      item.label = isJA() ? t('1688国家货盘') : t('1688严选')
    } else {
      item.label = '1688'
    }
  }
  console.log(SellersList, 'SellersList')

  return SellersList
})

const ranges = reactive([
  { value: ['', ''], name: '-', active: false },
  { value: ['10', '50'], name: '10-50', active: false },
  { value: ['50', '80'], name: '50-80', active: false },
  { value: ['80', '100'], name: '80-100', active: false }
])
const minPrice = ref('')
const maxPrice = ref('')

watch(
  params,
  (v) => {
    const { sellPriceStart, sellPriceEnd } = v
    ranges.forEach((v) => (v.active = false))
    const name = [sellPriceStart, sellPriceEnd].join('-')
    const match = ranges.find((v) => v.name === name)
    if (match) {
      match.active = true
      minPrice.value = ''
      maxPrice.value = ''
    } else {
      minPrice.value = sellPriceStart
      maxPrice.value = sellPriceEnd
    }
    categoryId.value = route.query.categoryId as string
  }, { immediate: true })

watch(() => route.query, () => {
  const filter = route.query.filters as string || ''
  const filterArr = filter.split(',')
  totalEpScoreLv.value = totalEpScoreLvOptions.filter(i => i.value && filterArr.includes(i.value))[0]?.value || ''
  getRate24HLv.value = getRate24HLvOptions.filter(i => i.value && filterArr.includes(i.value))[0]?.value || ''
  getRate48HLv.value = getRate48HLvOptions.filter(i => i.value && filterArr.includes(i.value))[0]?.value || ''
  serves.value = serveList.filter(i => i.value && filterArr.includes(i.value))[0]?.value || ''
  certifiedFactory.value = filterArr.includes('certifiedFactory')
  noReason7DReturn.value = filterArr.includes('noReason7DReturn')
}, { immediate: true })

const change = (v: any) => {
  if (v.schannel && v.schannel !== '') {
    v.platformType = ''
  }
  const query = {
    ...route.query,
    ...v
  }
  router.replace({ ...route, query })
}

const setRange = (...rest: string[]) => {
  change({
    sellPriceStart: rest[0],
    sellPriceEnd: rest[1]
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["list-label", _unref(useSite)()])
  }, [
    (__props.type !== 'shop' && !_unref(onShowNation))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('采购渠道')), 1),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(channels, (v) => {
              return _createElementVNode("span", {
                key: v.label,
                class: _normalizeClass([{ active: v.value === _unref(params).channel }, "row-label btn"]),
                onClick: ($event: any) => (change({ schannel: v.value }))
              }, _toDisplayString(_unref(t)(v.label)), 11, _hoisted_4)
            }), 64))
          ]),
          _hoisted_5
        ]))
      : _createCommentVNode("", true),
    (__props.type !== 'shop' && !_unref(onShowNation))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('采购市场')), 1),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sellers), (v) => {
              return (_openBlock(), _createElementBlock("span", {
                key: v.label,
                class: _normalizeClass(["row-label rel btn", { active: v.value === _unref(params).platformType }])
              }, [
                _createElementVNode("span", {
                  onClick: ($event: any) => (change({ platformType: v.value }))
                }, _toDisplayString(_unref(t)(v.label)), 9, _hoisted_9),
                (v.tagImg && !_unref(route).query.productCode)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: `https://static-s.theckb.com/BusinessMarket/icon/1688selected/home-selected-tips-${_unref(useSite)()}.png`,
                      alt: ""
                    }, null, 8, _hoisted_10))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128))
          ]),
          _hoisted_11
        ]))
      : _createCommentVNode("", true),
    (_unref(onShowNation))
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)('分类')), 1),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_el_select, {
                onChange: changeCategoryId,
                modelValue: categoryId.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((categoryId).value = $event)),
                class: "w200",
                placeholder: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(categrayList, (item) => {
                    return _createVNode(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(isNational))
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)('履约质量')), 1),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(t)('综合体验')), 1),
              _createVNode(_component_el_select, {
                onChange: _cache[1] || (_cache[1] = ($event: any) => (changeFilter($event, 'totalEpScoreLvOptions'))),
                modelValue: totalEpScoreLv.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((totalEpScoreLv).value = $event)),
                class: "score-select-120",
                placeholder: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(totalEpScoreLvOptions, (item) => {
                    return _createVNode(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_el_checkbox, {
                "true-label": "certifiedFactory",
                modelValue: certifiedFactory.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((certifiedFactory).value = $event)),
                onChange: _cache[4] || (_cache[4] = ($event: any) => (changeFilter($event, 'certifiedFactory'))),
                label: _unref(t)('认证工厂')
              }, null, 8, ["modelValue", "label"])
            ])
          ]),
          _hoisted_22
        ]))
      : _createCommentVNode("", true),
    (_unref(isNational))
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(t)('服务保障')), 1),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_el_radio_group, {
                max: 1,
                modelValue: serves.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((serves).value = $event)),
                onChange: _cache[6] || (_cache[6] = ($event: any) => (changeFilter($event, 'serveList')))
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(serveList, (item) => {
                    return _createVNode(_component_el_radio, {
                      label: item.value,
                      key: item.label
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_el_checkbox, {
                "true-label": "noReason7DReturn",
                modelValue: noReason7DReturn.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((noReason7DReturn).value = $event)),
                onChange: _cache[8] || (_cache[8] = ($event: any) => (changeFilter($event, 'noReason7DReturn'))),
                label: _unref(t)('7天无理由')
              }, null, 8, ["modelValue", "label"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(t)('价格')), 1),
      _createElementVNode("div", _hoisted_30, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ranges), (v) => {
          return (_openBlock(), _createElementBlock("span", {
            key: v.name,
            class: _normalizeClass([{ active: v.active }, "row-label btn"]),
            onClick: ($event: any) => (setRange(...v.value))
          }, _toDisplayString(v.name === '-' ? _unref(t)('全部') : v.name), 11, _hoisted_31))
        }), 128)),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("label", _hoisted_33, _toDisplayString(_unref(t)('自定义')), 1),
          _createVNode(PriceRange, {
            small: "",
            class: "ml_10",
            min: minPrice.value,
            "onUpdate:min": _cache[9] || (_cache[9] = ($event: any) => ((minPrice).value = $event)),
            max: maxPrice.value,
            "onUpdate:max": _cache[10] || (_cache[10] = ($event: any) => ((maxPrice).value = $event))
          }, null, 8, ["min", "max"]),
          (minPrice.value || maxPrice.value)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (setRange(minPrice.value, maxPrice.value))),
                style: {"margin-left":"40px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('确认')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 2))
}
}

})